import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  breadcrumbProps: {
    separator: '>',
  },
  // siderWidth: 320,
  navTheme: 'light',
  colorPrimary: '#1890ff',
  title: '',
  layout: 'side', // Thay đổi sang 'side' để có aside bên trái, header + body bên phải
  contentWidth: 'Fixed', // Giữ 'Fixed' để giới hạn chiều rộng nội dung
  fixedHeader: true, // Giữ header cố định
  fixSiderbar: true, // Giữ sidebar cố định
  colorWeak: false,
  pwa: true,
  iconfontUrl: '',
  collapsedButtonRender: false,
  logoStyle: {
    borderBlockEnd: 'none',
  },
  // bgLayoutImgList: [
  //   {
  //     src: '/images/bg-home.png',
  //     left: 0,
  //     bottom: 0,
  //     right: 0,
  //     top: 60,
  //   },
  // ],
  token: {
    bgLayout: '#F9FAFB',
    sider: {
      colorMenuBackground: '#0060AF',
      paddingInlineLayoutMenu: 5,
      paddingBlockLayoutMenu: 4,
    },
    header: {
      colorBgHeader: '#0060AF',
    },
  },
  disableMobile: false,
};

export default Settings;
